/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
  ----------------------------------------------------------------------------------------
  Item Name: Pre-Pulse
  
==========================================================================================*/


const mutations = {

  SetOpenBatchesList (state, payload){
    state.openBatchesList = payload
  },
  SetBatchStatesList(state, payload){
    //for(var i = 0; i < payload.length; i++){
    if(payload != null){
      if(payload.length != 0){
        if(payload[0].StateOfLoss == ""){
          payload[0].StateOfLoss = "NONE"
        }
      }
    }
    //}
    state.batchStatesList = payload
  },
  SetMyHoldList (state, payload){
    state.myHoldList = payload
  },
  SetMySupReviewList (state, payload){
    state.mySupReviewList = payload
  },
  SetIncident(state, payload){
    state.incident = payload
  },
  SetIncidentClaims(state, payload){
    state.incidentClaims = payload
  },
  SetIncidentSupplements(state, payload){
    state.incidentSupplements = payload
  },
  SetEverythingCleared(state, payload){
    state.openBatchesList = []
    state.batchStatesList = []
    state.myHoldList = []
    state.mySupReviewList = []
    state.incident = {}
    state.incidentClaims = []
    state.incidentSupplements = []
  }
}

export default mutations

